import type { MutationHookOptions } from '@apollo/client'
import {
  PeopleChartUpdateTeamDocument,
  PeopleChartUpdateTeamMutation,
  PeopleChartUpdateTeamMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  PeopleChartUpdateTeamMutation,
  PeopleChartUpdateTeamMutationVariables
>

export const useUpdateTeam = (options?: Options) => {
  const [updateTeam, { loading }] = useMutation(PeopleChartUpdateTeamDocument, {
    ...options,
    extractorFn: (x) => x.teamsMutations.updateTeamsTeam,
  })

  return {
    loading,
    updateTeam,
  }
}
